<template>
    <ul class="product-list-ul">
        <li 
            class="product-list-li" 
            v-for="v in list" 
            :key="v.id" 
        >
            <div 
                v-for="k in v.data" 
                :class="{'image-box': k.type == 'image', 'text-box': k.type == 'text'}"  
                :key="k.id"
            >
                <template v-if="k.type =='image'">
                    <img :src="k.src">
                </template>

                <template v-if="k.type == 'text'">
                    <h3 class="title">
                        <span>{{k.title}}</span>
                        <div class="line"></div>
                    </h3>
                    <p class="text">
                        {{k.text}}
                    </p>
                    <router-link 
                        class="btn" 
                        :to="k.link"
                    >
                        {{k.btn}}
                    </router-link>
                </template>
                <div class="flex-space-between-fix"></div>
            </div>
        </li>
    </ul>
</template>
<script>
    
// import jquery from 'jquery'

export default {
    name: 'BaseListUlmoudle2',
    props: {
        list: Array
    },
    data: function() {
        return {

        }
    },
    updated: function() {

    },
    mounted() {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
